import React, { PropsWithChildren, Children, CSSProperties } from 'react'

import * as S from './styles'

export type GridContainerProps = PropsWithChildren<{
  /**
   * Define the number of columns in the grid
   *
   * @example
   * ```tsx
   * <GridContainer columns={3} />
   * <GridContainer columns="1fr 1fr 1fr" />
   * <GridContainer columns={{ repeat: 3, size: '1fr' }} />
   * ```
   *
   */
  columns?:
    | number
    | string
    | {
        repeat: number
        size: string
      }

  /**
   * The style prop is used to pass styles to the component.
   *
   * @example
   * ```tsx
   * <FlexContainer style={{padding: "16px"}} />
   * ```
   *
   */
  style?: CSSProperties
}>

export const GridContainer: React.FC<GridContainerProps> = ({
  columns,
  style,
  children,
}) => (
  <S.Grid
    columns={columns}
    style={style}
    totalChildren={Children.count(children)}
  >
    {children}
  </S.Grid>
)
